import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { MemberService } from './../../../../../../rest/api/member.service';
import { AuthService } from './../../../../../../services/auth.service';

@Component({
  selector: 'app-infohotspot-list',
  templateUrl: './infohotspot-list.component.html',
  styleUrls: ['./infohotspot-list.component.scss']
})
export class InfohotspotListComponent implements OnInit {
  @Input() infohotspotListData;
  @Input() spaceData;
  @Input() mediaData;
  @Input() selectedMedia;
  @Output() changeHotspotEmit = new EventEmitter();
  @Output() closeMenuEmit = new EventEmitter();
  @Output() showHideInfoEmit = new EventEmitter();
  showinfoHotspotData: any;
  accessToken: any;


  constructor(
    public memberService: MemberService,
    public authService: AuthService
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
  }
  changeHotspot(hotspot) {
    // if (hotspot && hotspot.media_id && this.selectedMedia && this.selectedMedia.uuid !== hotspot.media_id) {
    this.changeHotspotEmit.emit(hotspot);
    // }
  }

  closeMenu() {
    this.closeMenuEmit.emit(true);
  }

  showHideInfo() {
    this.memberService.showHideInfo({
      Authorization: this.accessToken,
      id: this.infohotspotListData.uuid
    }).subscribe((response: any) => {
      this.showinfoHotspotData = response && response.data ? response.data : [];
    }, err => {
      this.showinfoHotspotData = [];
    });
  }

  showHideInfoHotspot(infohotspot) {
    this.memberService.showHideInfo({
      Authorization: this.accessToken,
      id: infohotspot.uuid
    }).subscribe(
      (res: any) =>  {
        this.showHideInfoEmit.emit(res && res.data ? res.data : undefined);
      },
      (err) => {
      }
    );
  }

}
